import IconButton from "@material-ui/core/IconButton";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import RefreshIcon from "@material-ui/icons/Refresh";
/* Unfinished functionality.
import SaveAltIcon from "@material-ui/icons/SaveAlt"; */
import TableChartIcon from "@material-ui/icons/TableChart";
import PropTypes from "prop-types";
import React from "react";

import Filter from "@components/Filter";

const useStyles = makeStyles(() => ({
  controlBar: {},
  controlBarRight: {
    position: "relative",
    textAlign: "right",
  },
  controlBarFilter: {
    paddingTop: "12px",
    paddingBottom: "12px",
  },
  "@media all and (min-width: 768px)": {
    controlBar: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
  },
}));

const CrudTableControl = (props) => {
  const classes = useStyles();
  const [exportMenuEl, setExportMenuEl] = React.useState(null);

  /* Unfinished functionality.
  function handleClickExportMenu(event) {
    setExportMenuEl(event.currentTarget);
  } */

  function handleCloseExportMenu() {
    setExportMenuEl(null);
  }

  function handleClickExportPDF() {
    props.onExportPDF();
    handleCloseExportMenu();
  }

  function handleClickExportCSV() {
    props.onExportCSV();
    handleCloseExportMenu();
  }

  return (
    <div>
      <div className={classes.controlBar}>
        <div className={classes.controlBarFilter}>
          {props.filter && (
            <Filter
              rows={props.rows}
              fields={props.filterFields}
              onFilter={props.onFilter}
            />
          )}
        </div>
        <div className={classes.controlBarRight}>
          {/* Unfinished functionality.
          <IconButton onClick={handleClickExportMenu} aria-label="exportar">
            <SaveAltIcon />
          </IconButton>*/}
          {props.refresh && (
            <IconButton onClick={props.onRefresh} aria-label="excluir">
              <RefreshIcon />
            </IconButton>
          )}
        </div>
      </div>
      <Menu
        anchorEl={exportMenuEl}
        keepMounted
        open={Boolean(exportMenuEl)}
        onClose={handleCloseExportMenu}
      >
        <MenuItem onClick={handleClickExportPDF}>
          <ListItemIcon>
            <PictureAsPdfIcon />
          </ListItemIcon>
          Exportar PDF
        </MenuItem>
        <MenuItem onClick={handleClickExportCSV}>
          <ListItemIcon>
            <TableChartIcon />
          </ListItemIcon>
          Exportar CSV
        </MenuItem>
      </Menu>
    </div>
  );
};

CrudTableControl.propTypes = {
  filter: PropTypes.bool,
  filterFields: PropTypes.array,
  refresh: PropTypes.bool,
  rows: PropTypes.array,
  onFilter: PropTypes.func,
  onRefresh: PropTypes.func,
  onExportPDF: PropTypes.func,
  onExportCSV: PropTypes.func,
};

CrudTableControl.defaultProps = {
  filter: false,
  filterFields: [],
  rows: [],
  refresh: true,
  onFilter: () => {},
  onRefresh: () => {},
  onExportPDF: () => {},
  onExportCSV: () => {},
};

export default CrudTableControl;
